export enum TutorialType {
  NEWS_ARCHIVE = 'news-archive',
  HOME_INTRODUCTION = 'home-introduction',
  HOME_INTRODUCTION_MOBILE = 'home-introduction-mobile',
  WORKSPACE_WIDGET_ZONE = 'workspace-widget-zone',
  SOCIAL_CENTER = 'social-center',
  PUSH_NOTIFICATIONS = 'push-notifications',
  WORKSPACE_PAGE_FEEDBACK = 'workspace-feedback',
  JOB_SURVEY_REMINDER_2 = 'jobsurvey-2',
  IOS_PWA = 'ios-pwa',
  ANROID_PWA = 'android-pwa',
}

export const ALL_TUTORIALS: TutorialType[] = Object.keys(TutorialType).map(key => TutorialType[key]);

